'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = require('../utils');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/** main CSE class */
var Permission = function () {

  /** CSE constructor */
  function Permission(options) {
    _classCallCheck(this, Permission);

    // Do not store token here.
    this.apiOptions = options;
  }

  _createClass(Permission, [{
    key: 'getUserPermissions',
    value: function getUserPermissions() {
      var _this = this;

      return new Promise(function (resolve, reject) {
        var path = ['projects', _this.apiOptions.projectId, 'permissions', 'me'];

        _utils.NetUtil.apigee(_this.apiOptions).get(path.join('/')).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          return reject(error);
        });
      });
    }
  }, {
    key: 'getProjectPermissions',
    value: function getProjectPermissions() {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        var path = ['projects', _this2.apiOptions.projectId, 'permissions'];

        _utils.NetUtil.apigee(_this2.apiOptions).get(path.join('/')).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          return reject(error);
        });
      });
    }
  }, {
    key: 'deleteProjectPermission',
    value: function deleteProjectPermission(permissionId) {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        if (!permissionId) {
          reject(new Error('Permission ID must be specified'));
        }

        var path = ['projects', _this3.apiOptions.projectId, 'permissions', permissionId];

        _utils.NetUtil.apigee(_this3.apiOptions).delete(path.join('/')).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          return reject(error);
        });
      });
    }
  }, {
    key: 'batchCreatePermissions',
    value: function batchCreatePermissions(permissions) {
      var _this4 = this;

      return new Promise(function (resolve, reject) {
        if (!permissions || !permissions.length) {
          reject(new Error('Permissions array must be specified (and not empty)'));
        }

        var path = ['projects', _this4.apiOptions.projectId, 'permissions:batch-create'];

        _utils.NetUtil.apigee(_this4.apiOptions).post(path.join('/'), permissions).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          return reject(error);
        });
      });
    }
  }]);

  return Permission;
}();

exports.default = Permission;